import('./main').then(main => main.default());
